import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { DepositTxnCategoryContainerModel } from '../../../../../models/aggregates/deposit-txn-category';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class DepositTxnCategoryService extends BaseApiPublicLoginTemplateService<DepositTxnCategoryContainerModel,DepositTxnCategoryContainerModel,DepositTxnCategoryContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-txn-category-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-txn-category-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-txn-category-hdrs/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit-txn-category-hdrs/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }
}